/**
 * LINE連携リクエスト
 */
export interface LineLinkRequest {
  invitation_token: string;
  line_access_token: string;
  /** LINEのIDトークン（メールアドレス取得のフォールバック用） */
  line_id_token?: string;
}

/**
 * LINE連携レスポンス
 */
export interface LineLinkResponse {
  success: boolean;
  company_code: string;
  staff_code: string;
  staff_name: string;
  line_user_id: string;
  line_display_name: string;
  cognito_user_created: boolean;
  /** ID Token（連携後の自動ログイン用） */
  id_token: string | null;
  /** Access Token（連携後の自動ログイン用） */
  access_token: string | null;
  /** Refresh Token（連携後の自動ログイン用） */
  refresh_token: string | null;
  /** トークンの有効期限（秒） */
  expires_in: number | null;
  /** メールアドレス（staff.mail優先、LINEメールフォールバック） */
  email: string | null;
  message: string;
}

/**
 * LINE認証リクエスト
 */
export interface LineAuthRequest {
  line_access_token: string;
  /** LINEのIDトークン（メールアドレス取得のフォールバック用） */
  line_id_token?: string;
}

/**
 * LINE認証レスポンス
 */
export interface LineAuthResponse {
  id_token: string;
  access_token: string;
  refresh_token: string;
  expires_in: number;
  company_code: string;
  staff_code: string;
  staff_name: string;
  email: string;  // staff.mail（FLAROに登録されたメールアドレス）
  line_user_id: string;
  line_display_name: string;
}

/**
 * LINE連携解除リクエスト
 */
export interface LineUnlinkRequest {
  line_access_token: string;
}

/**
 * LINE連携解除レスポンス
 */
export interface LineUnlinkResponse {
  success: boolean;
  company_code: string;
  staff_code: string;
  message: string;
}

/**
 * LINE連携エラーコード
 */
export type LineErrorCode =
  | 'LINE_ALREADY_LINKED'
  | 'EMAIL_REQUIRED'
  | 'LINE_NOT_LINKED'
  | 'INVALID_LINE_TOKEN'
  | 'COGNITO_USER_NOT_FOUND'
  | 'INTERNAL_ERROR';

/**
 * LINE連携エラーレスポンス
 */
export interface LineErrorResponse {
  code: LineErrorCode;
  message: string;
}

/**
 * エラーコードに対応するユーザー向けメッセージ
 */
export const LINE_ERROR_MESSAGES: Record<LineErrorCode, string> = {
  LINE_ALREADY_LINKED: 'このLINEアカウントは既に別のスタッフと連携されています。',
  EMAIL_REQUIRED: 'LINEのメールアドレスが取得できません。LINEアプリでメール設定を行ってください。',
  LINE_NOT_LINKED: 'LINE連携が必要です。管理者から招待を受けてください。',
  INVALID_LINE_TOKEN: '認証に失敗しました。再度お試しください。',
  COGNITO_USER_NOT_FOUND: 'アカウントが見つかりません。管理者にお問い合わせください。',
  INTERNAL_ERROR: 'システムエラーが発生しました。しばらくしてから再度お試しください。',
};
